import {
  type CMSApiBase,
  type CMSGroupParams,
  type CMSImageBase,
  createCmsUrl,
} from '@/api/cms/base';
import type { CMSFaq, CMSSteps } from '@/api/cms/restrictions';
import { fetcherCMS } from '@/modules/api';
import { getCMSLocale } from '@/modules/cms';

export interface LoyaltyPerk {
  id: number;
  title: string;
  description: string;
  isAvailable: boolean;
}

export interface LoyaltyLevel extends CMSGroupParams {
  id: number;
  title: string;
  blur: string;
  image: CMSImageBase;
  background: CMSImageBase;
  animatedElement: CMSImageBase;
  animatedElement2: CMSImageBase;
  perks: LoyaltyPerk[];
  groupKey: string;
}

/** @deprecated Use LoyaltyLevel instead */
export type ILevel = LoyaltyLevel;

export interface LoyaltyCardCTAs {
  ctaCardDeposit: string;
  ctaCardCompleted: string;
  ctaCardFuture: string;
  ctaCardLast: string;
  ctaCardLobby: string;
}

export interface LoyaltyProgramApi extends CMSApiBase, LoyaltyCardCTAs {
  title: string;
  description: string;
  countdownTitle: string;
  stepsTitle: string;
  faqsTitle: string;
  ctaPageRegistration: string;
  ctaPageDeposit: string;
  levels: LoyaltyLevel[];
  faqs: CMSFaq[];
  steps: CMSSteps[];
  tooltipTextForNotSecuredLevel: string;
  tooltipTextForSecuredLevel: string;
}

export const getLoyaltyProgramCMSUrl = (lang: string) =>
  createCmsUrl({
    path: 'loyalty-program',
    queryData: { populate: 'deep', ...getCMSLocale(lang) },
  });

export const fetchLoyaltyProgramCMS = async (lang: string) => {
  const response = await fetcherCMS<LoyaltyProgramApi>(
    getLoyaltyProgramCMSUrl(lang)
  );
  return { data: response };
};
